export default __webpack_public_path__ + "static/media/img_8_thumb.969e9247.JPG";